export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_TASKS = 'GET_USER_TASKS';
export const GET_USER_PROJECT_BY_ID = 'GET_USER_PROJECT_BY_ID';
export const CLEAR_USER_PROFILE = 'CLEAR_USER_PROFILE';
export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const EDIT_FIRST_NAME = 'EDIT_FIRST_NAME';
export const GET_PROJECT_BY_USER_NAME = 'GET_PROJECT_BY_USER_NAME';
export const USER_NOT_FOUND_ERROR = 'USER_NOT_FOUND_ERROR';
export const GET_USER_AUTOCOMPLETE = 'GET_USER_AUTOCOMPLETE';
